import { useTheme } from '@mui/styles';

import { CELL_SPACING, DAY_GRAY, LEFT_COLUMN } from '../../../../constants';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    contentWrapper: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    tableWrapper: {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      paddingTop: theme.spacing(0.3),
      overflowX: 'hidden',
      overflowY: 'auto',
      borderTop: `1px solid ${DAY_GRAY}`,
    },
    leftCells: {
      width: `${LEFT_COLUMN}px`,
      alignSelf: 'flex-end',
      fontWeight: 'bold',
      flexShrink: 0,
    },
    rightCells: {
      flexGrow: 1,
      overflow: 'hidden',
    },
    calendarHeaderWrapper: {
      width: '100%',
      display: 'flex',
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      marginBottom: `${CELL_SPACING}px`,
    },
    minLeftCell: {
      width: '50px',
      alignSelf: 'flex-end',
      fontWeight: 'bold',
      flexShrink: 0,
      overflow: 'hidden',
      paddingRight: theme.spacing(1),
    },
  };
};
